import React from 'react'
import styled, { keyframes } from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import tw from 'twin.macro'
import { Column } from '@ui-kit/helpers'
import Prose from '@ui-kit/atoms/prose'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import * as styles from './strapline-image-detail.module.css'


const StraplineImageDetail = ({ body, strapline, r: { image }, env = process.env.GATSBY_SITE, ...props }) => {
    return (
        <Column className={['promotion', styles.straplineImageDetail].join(' ')}>
            <Style>
                    <figure>
                        <div>
                            {image && (
                            <GatsbyImage
                                image={getImage(image.r.image.file.childImageSharp)}
                                {...image.meta}
                            />
                            )}
                        </div>
                        { strapline && <figcaption>{strapline}</figcaption>}
                    </figure>

                { body && <Prose element={'article'} env={env} html={body.html} />}
                { /*body && <article className="prose" dangerouslySetInnerHTML={{__html: body.html}} />*/ }
            </Style>
        </Column>
    )
}
export default StraplineImageDetail


const Style = styled.section.attrs(props => ({
    className: 'promotion promotion--strapline-image-detail'
}))`
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0 8vmax;
    ${tw `flex flex-col md:grid gap-y-6`}

    figure {
        ${tw `flex flex-col-reverse`}

        img {
            ${tw `h-auto mb-0`}
        }

        > figcaption {
            ${tw `text-pink leading-none font-bold`}
            font-size: calc(1em + 2.5vmax);

            ${breakpoint('sm')`
                font-size: calc(1em + 4vmax);
            `}

            ${breakpoint('xlg')`
                padding-left: 6vw;
                padding-right: 2vw;
                font-size: calc(1em + 7vmax);
            `}

            ${breakpoint('xmg')`
                font-size: 130px;
            `}

            opacity: 0;
            animation-name: ${keyframes`
                from {
                    opacity: 0;
                    transform: translateY(-10vh);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            `};
            animation-delay: 0.5s;
            animation-duration: 0.35s;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
            animation-timing-function: ease-in-out;


            @media (prefers-reduced-motion: reduce) {
                ${tw `transform-none opacity-100 animate-none`}
            }
        }

        > div {
            opacity: 0;
            animation-name: ${keyframes`
                from {
                    opacity: 0;
                    transform: translateY(-10vh);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            `};
            animation-delay: .1s;
            animation-duration: 0.35s;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
            animation-timing-function: ease-in-out;

            @media (prefers-reduced-motion: reduce) {
                ${tw `transform-none opacity-100 animate-none`}
            }
        }
    }

    article {
        ${tw `space-y-[.85em] lg:self-end text-xl lg:fontSize[calc(.5em + .75vmax)]`}
        line-height: 1.611;
        opacity: 0;
        animation-delay: 0.9s;
        animation-duration: 0.35s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        animation-timing-function: ease-in-out;
        animation-name: ${keyframes`
                from {
                    opacity: 0;
                    transform: scale(.6);
                }
                to {
                    opacity: 1;
                    transform: scale(1);
                }
        `};

        @media (prefers-reduced-motion: reduce) {
            ${tw `animate-none opacity-100 transform-none`}
        }

        p:has(small) {
            ${tw `leading-snug`}
        }

        small {
            ${tw `text-base leading-snug`}

            a {
                ${tw `underline underline-offset-2`}
            }
        }

        h2 {
            ${tw `font-semibold text-3xl mg:text-5xl`}
        }

        ul + p {
            ${tw `mt-[1em]`}
        }
    }

    dl + dl {
        ${tw `mt-3`}
    }

    dt {
        font-weight: normal;
        float: left;
        margin-right: .25em;
    }

    dd {
        margin: 0;
        padding: 0;
    }

    dl a {
        ${tw `text-default outline-none focus:text-orange hover:text-primary active:text-primary`}
    }

    dl.lead dd {
        ${tw `font-bold leading-none w-full`}
        font-size: calc(1em + 2vmax);
        clear: both;
    }

    a.btn {
        ${tw `bg-primary text-black transition-colors hover:bg-black hover:text-white focus-visible:bg-orange focus-visible:text-white rounded-3xl px-[1.75em] inline-flex mt-5 leading-none py-[.65em] truncate font-semibold`}
    }
`